<style>
.welcome {
  width: 100%;
  height: 700px;
  max-height: 800px;
  background-color: #1376EB;
  overflow: hidden;
}
@keyframes floatCloudY {
  from { background-position: 0 0; }
  to { background-position: 0 700px; }
}
@keyframes floatCloudX {
  from { background-position: 0 0; }
  to { background-position: 1920px 0; }
}
@media (min-width: 1200px){
  .welcome {
    background-image: url("../../assets/index/welcome.png");
    background-size: cover;
    background-position: center;
    /*background-repeat: repeat-y;
    animation: floatCloudY 5s linear infinite;*/
  }
}
.welcome>.main{
  height: 100%;
  position: relative;
  color:white;
}
.welcome>.main>h1.title{
  padding-top: 200px;
  margin-top: 0;
  font-weight: bold;
  font-size: 50px;
  margin-bottom: 18px;
}
.welcome>.main>p.remark{
  font-size: 18px;
  margin-bottom: 18px;
}
.welcome>.main>p.remark{
  font-size: 18px;
  margin-bottom: 18px;
}
.welcome>.main>p.form-controls>.text-search{
  border: 1px solid white;
  color: #555;
  font-family: Microsoft YaHei;
  border-radius: 3px;
  font-size: 17px;
  outline: none;
  padding: 0 10px;
  height: 40px;
  padding-right: 118px;
  width: 450px;
}
.welcome>.main>p.form-controls>.btn-search{
  font-size: 17px;
  padding: 0 18px;
  height: 40px;
  /*line-height: 40px;*/
  border-radius: 0;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  outline: none;
  color: white;
  position: absolute;
  margin-left: -103px;
}
.welcome>.main>.cloud{
  background-image: url("../../assets/index/cloud.svg");
  width: 840px;
  height: 187px;
  background-repeat: no-repeat;
  position: absolute;
  bottom: -4px;
  right: 0;
}
.welcome>.main>.rocket{
  height: 525px;
  background-repeat: no-repeat;
  position: absolute;
  width: 125px;
  bottom: 0;
  right: 337px;
  background-image: url("../../assets/index/rocket.svg");
}
@media screen and (max-width : 1024px) {
  .welcome>.main>.rocket{
    right: 211px;
  }
}
</style>

<template>
  <div class="welcome">
    <div class="main container">
      <h1 class="title">搜索引擎优化指数查询</h1>
      <p class="remark">15年SEO品牌 匠心之法修炼内功 让您的排名提升如此简单</p>
      <p class="form-controls">
        <input type="text" class="text-search" v-model="word" placeholder="输入关键词" v-on:keydown="submitSearch" />
        <el-button type="default" class="btn-search" v-on:click="search">指数查询</el-button>
      </p>
      <transition  enter-active-class="animated fadeInUp">
        <div v-show="cloudIsIn" class="cloud"></div>
      </transition>
      <transition enter-active-class="animated fadeInUp">
        <div v-show="rocketIsIn" class="rocket"></div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welcome',
  data () {
    return {
      cloudIsIn: false,
      rocketIsIn: false,
      word: ''
    }
  },
  methods: {
    submitSearch ($event) {
      if ($event.keyCode === 13) {
        this.search()
      }
    },
    search ($event) {
      if (!this.word) { return false }
      this.$router.push({
        name: 'search',
        params: {
          word: this.word
        }
      })
    }
  },
  mounted () {
    this.rocketIsIn = true
    setTimeout(() => {
      this.cloudIsIn = true
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// welcome.vue?93aebdb6